import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import './Home.css';

class Home extends Component {
  render() {
    return (
      <div className='home-banner-group'>
        <Image src={require("../assets/home-banner.jpg")} className='home-banner-image' />
        <div className='home-banner-text'>
          <h2>Welcome to Megadigm&#8480;</h2>
          <p>Power your IoT smarts in realtime</p>
        </div>
      </div>
    );
  }
}

export default Home;